import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import {
  CloneQuoteMutation,
  CloneQuoteMutationVariables,
} from '../gql/graphql';
import { GET_QUOTES } from './quotes.query';
import { GET_RATER } from './rater.query';

export const CLONE_QUOTE = graphql(`
  mutation cloneQuote(
    $submissionUuid: String!
    $quoteUuid: String!
    $isRenewal: Boolean!
  ) {
    cloneQuote(
      quoteUuid: $quoteUuid
      submissionUuid: $submissionUuid
      isRenewal: $isRenewal
    ) {
      uuid
      referenceId
    }
  }
`);

export function useCloneQuoteMutation(
  options: MutationHookOptions<
    CloneQuoteMutation,
    CloneQuoteMutationVariables
  > = {}
) {
  const [cloneQuote, { loading, error, reset }] = useMutation(CLONE_QUOTE, {
    refetchQueries: [GET_QUOTES, GET_RATER],
    ...options,
  });

  return {
    cloneQuote,
    loading,
    error,
    reset,
  };
}
